/*
  Input Email
*/

import React from 'react';

// Antd
import { Input, Form } from 'antd';

// Localization
import LOCALIZATION from '../../../../services/LocalizationService';

// Style
import './style.scss';

function Email({ 
  name, label, 
  placeholder, defaultValue, 
  onChange, disabled, required,
  onBlur, validateTrigger,
  validator, notwrapInForm,
  rules: propRules,
}) {

  let rules = [
    { required: required === true, message: LOCALIZATION.REQUIRED },
    { type: 'email', message: LOCALIZATION.INVALID_EMAIL },
  ];

  if (propRules && Array.isArray(propRules) && propRules.length > 0) {
    rules = rules.concat(propRules);
  }
  if (validator) {
    rules.push(validator);
  }

  // Input Email
  const InputEmail = (
    <Input 
      placeholder={ placeholder || label } 
      onChange={ onChange || null } 
      defaultValue={ defaultValue }
      disabled={ disabled }
      onBlur={ onBlur || null }
    />
  );
  
  return(
    !!notwrapInForm?
      <>
        { InputEmail }
      </>:
      <Form.Item
        name={ name }
        label={ label }
        validateTrigger={ validateTrigger || 'onBlur' }
        rules={ rules }
        
        data-testid='form'
      >
        { InputEmail }
      </Form.Item>
  );
}

export default Email;